import { Component } from 'preact';
import PropTypes from 'prop-types';
import CSSTransition from 'react-transition-group/CSSTransition';
import classNames from 'classnames';
import BaseSection from './Base';

// Components
import CurrentProgress from './CurrentProgress';
import ProgressBar from '../ProgressBar';
import { getStep } from '../../utilities/adobeTarget';
import Text from '../Global/Text';
import { calculationJourneyAction } from '../../actions/UserData';
import ProgressBarCompact from '../ProgressBarCompact';
import ErrorPage from '../Page/ErrorPage';
import { identifyCustomError } from '../../utilities/error';

class Section extends Component {
  constructor(props) {
    super(props);
    this.onExitingCallback = this.onExitingCallback.bind(this);
    this.trackingClick = this.trackingClick.bind(this);
  }

  onExitingCallback(node) {
    const { error } = this.props;
    // CSS transtition will not finish its cycle on error. Force a reset in that case.
    if (error) {
      node.classList.remove('price-exit');
      node.classList.remove('price-exit-active');
    }
  }

  setShapeStyle(shape) {
    const shapeStyle = {
    };
    if (shape) {
      if (shape.backgroundColor) {
        shapeStyle['background-color'] = shape.backgroundColor;
      }
      if (shape.radius) {
        shapeStyle['border-radius'] = shape.radius;
      }
      if (shape.contentColor) {
        shapeStyle.color = shape.contentColor;
      }
      if (shape.top) {
        shapeStyle.top = shape.top;
      }
      if (shape.left) {
        shapeStyle.left = shape.left;
      }
      if (shape.diameter) {
        shapeStyle.width = shape.diameter;
        shapeStyle.height = shape.diameter;
      }
    }
    return shapeStyle;
  }

  trackingClick() {
    const { dispatch, userData, activeSectionData } = this.props;
    if (!userData.calculationJourneyStarted && activeSectionData.sectionId === 1) {
      dispatch(calculationJourneyAction());
    }
  }

  render() {
    const {
      actions,
      price,
      loaderProgress,
      currentSectionId,
      finishedSections,
      packageData,
      sectionOrder,
      currentProgress,
      userData,
      activeSectionData,
      currentProgress: {
        hideProgress = false,
        hideCurrentProgress,
        errorPageConfig
      },
      activeSectionData: {
        sectionWidth,
      },
      error,
      errorData
    } = this.props;
    let stepClass = 'step-unknown';
    let customError = false;
    let customErrorCode;
    const data = getStep();
    if (data) {
      stepClass = data.replaceAll('.', '-');
    }
    const sectionClass = classNames(
      stepClass.replace(/\./g, '-'),
      'inner',
      'section__inner', {
        [`inner--${sectionWidth}`]: sectionWidth && !error,
      }
    );
    const styles = {
      'background-image': 'none',
    };
    if (activeSectionData.displayImage) {
      styles['background-image'] = `url(${activeSectionData.imageUrl})`;
    }
    let sectionClassLeft;
    let progressBarSectionClass;
    if (activeSectionData.displayImage) {
      sectionClassLeft = 'section--left-v2';
      progressBarSectionClass = 'section--progressbar-compact-img';
    } else {
      sectionClassLeft = 'section--full-v2';
      progressBarSectionClass = 'section--progressbar-compact-noimg';
    }

    const promoStyle = {
      'background-color': 'none',
    };
    if (activeSectionData.displayPromoText) {
      promoStyle['background-color'] = activeSectionData.promoTextBackgroundColor;
      promoStyle.color = activeSectionData.promoTextColor;
    }
    const promoShape = activeSectionData.displayPromoShape || 'circle';

    const productTagStyle = this.setShapeStyle(activeSectionData.productTag);
    const splashStyle = this.setShapeStyle(activeSectionData.splash);

    // This will trigger the functions which will handle the custom errors.
    if(identifyCustomError(packageData.initialValues.errorPageConfig.customErrors, userData).customErrorResult === true){
      customError = true;
      customErrorCode = identifyCustomError(packageData.initialValues.errorPageConfig.customErrors, userData).customErrorCode;
    }

    return (
        error || customError ?
        <ErrorPage                     
          actions={actions}
          userData={userData}
          activeSectionData={activeSectionData}
          errorPageConfig={errorPageConfig || packageData.initialValues.errorPageConfig}
          packageData={packageData}
          compactLayout={currentProgress.compactLayout}
          customErrorCode={customErrorCode}
        />
        :
        /* eslint-disable-next-line */
        <div onClick={(e) => { this.trackingClick(e); }}>
        {activeSectionData.compactLayout &&
        <div className={progressBarSectionClass}>
          <ProgressBarCompact
            currentProgress={currentProgress}
            error={error}
            currentSectionId={currentSectionId}
            finishedSections={finishedSections}
            packageData={packageData}
            sectionOrder={sectionOrder}
          />
        </div>
        }
        <div
          className="section--container-v2"
        >
          <article className={sectionClassLeft}>
            <div className={sectionClass}>
              {/* Progress Bar */}
              <CSSTransition
                in={error || !hideProgress}
                timeout={300}
                classNames="fadeIn"
                unmountOnExit
              >
                <aside className="progress">
                  {!activeSectionData.compactLayout &&
                    <ProgressBar
                      currentProgress={currentProgress}
                      currentSectionId={currentSectionId}
                      error={error}
                      finishedSections={finishedSections}
                      packageData={packageData}
                      sectionOrder={sectionOrder}
                    />
                  }
                  {/* Current Progress */}
                  <CSSTransition
                    in={!error && !hideCurrentProgress}
                    timeout={300}
                    classNames="fadeIn"
                    unmountOnExit
                  >
                    <CurrentProgress currentProgress={currentProgress}/>
                  </CSSTransition>
                </aside>
              </CSSTransition>
              <BaseSection
                actions={actions}
                activeSectionData={activeSectionData}
                currentProgress={currentProgress}
                currentSectionId={currentSectionId}
                finishedSections={finishedSections}
                loaderProgress={loaderProgress}
                packageData={packageData}
                price={price}
                userData={userData}
                sectionOrder={sectionOrder}
                error={error}
                errorData={errorData}
              />
            </div>
          </article>
          {activeSectionData.displayImage &&
            <article className="section--right-v2" style={styles} >
              {activeSectionData.displayPromoText &&
                <div className={`${promoShape}-promo`} style={promoStyle} >
                  <Text
                    value={activeSectionData.displayPromoText}
                  />
                </div>
              }
              {activeSectionData.splash &&
                <div className="splash" style={splashStyle} >
                  <Text
                    value={activeSectionData.splash.content}
                  />
                </div>
              }
              {activeSectionData.productTag &&
                <div className="product-tag" style={productTagStyle} >
                  <Text
                    value={activeSectionData.productTag.content}
                  />
                </div>
              }
            </article>
          }
        </div>
      </div>
    );
  }
}

export default Section;

Section.propTypes = {
  activeSectionData: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  currentProgress: PropTypes.object.isRequired,
  currentSectionId: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  loaderProgress: PropTypes.number.isRequired,
  finishedSections: PropTypes.array.isRequired,
  packageData: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  sectionOrder: PropTypes.array.isRequired,
  price: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  errorData: PropTypes.object.isRequired,
};
